import React from 'react';
import { Text } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { DesktopCard } from 'commons/components';
import { useTranslationWithPrefix } from 'commons/utils';

function IdentityValidationSkeleton(): JSX.Element {
  const { t } = useTranslationWithPrefix('identityValidation');
  return (
    <AppLayout title={t('title')}>
      <DesktopCard>
        <Text.Skeleton />
      </DesktopCard>
    </AppLayout>
  );
}

export default IdentityValidationSkeleton;
